module.exports = __webpack_public_path__ + "img/shm_logo_SNB.c26449d8.svg";